import axios from 'axios' // eslint-disable-line no-restricted-imports

/**
 * Axios instance for external/customer-facing endpoints
 */
const apiAxios = axios.create({
  baseURL: process.env.VITE_LOCAL_API_ENDPOINT_V2,
  withCredentials: true,
  timeout: 120000, // 2 minutes - should exceed server-side transaction timeouts
})

export const X_IS_ADMIN_CLIENT_HEADER = 'X-Is-Admin-Client'

/**
 * Axios instance for internal/admin-facing endpoints
 */
const adminApiAxios = axios.create({
  baseURL: process.env.VITE_LOCAL_ADMIN_API_ENDPOINT,
  withCredentials: true,
  timeout: 120000, // 2 minutes - should exceed server-side transaction timeouts
  headers: {
    [X_IS_ADMIN_CLIENT_HEADER]: 'true',
  },
})

export { apiAxios, adminApiAxios }
